/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { getStatusClass } from "../../../../../utils/utils";
export const UnityStatusTypeFormatter = (cellContent, row, rowIndex) => {
  const { unityfiStatus } = row;

  const renderStatus = () => {
    return (
      <span
        className={`${getStatusClass(
          unityfiStatus
        )} status-color text-capitalize`}
      >
        {unityfiStatus ? unityfiStatus : "-"}
      </span>
    );
  };

  return (
    <span className="text-center text-dark-75 d-block">{renderStatus()}</span>
  );
};
